/**
 * Created by Paul on 6/5/2017.
 */
import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {LotteryPage} from "../../pages/lottery/lottery";
import {AlertController, ToastController} from "ionic-angular";
import {AppDialog} from "../appDialog";

interface IBetHistory {
  bets: Array<number | string>;
  amount: number;
}

@Component({
  selector: 'sm-base',
  template: ''
})

export class SixMarkBaseComponent implements OnInit {
  _DEFAULT_BET_COIN_AMOUNT: number = 0;
  _IMG_LOTTERY_FOLDER_PATH: string = 'build/assets/images/lottery';
  _selectOption: any;
  _userBalance: number;

  // List of current bets - an array of option which is either number or string
  // private: not allow derived classes to access directly but through methods
  private currentBets = [];
  // betInfo
  public betInfo = [];
  // List of bets
  private betHistory = Array<IBetHistory>();
  // List of betHistory
  betHistoryArchive = [];
  // Maximum amount for one option
  maxAmountPerOption = 20000;
  // Maximum amount for one bet
  maxAmountPerBet = 100000;
  // Coin Images Map
  coinsImagePathMap = [
    {
      imgName: 'casino1.png',
      amount: 1
    },
    {
      imgName: 'casino1k.png',
      amount: 1000
    },
    {
      imgName: 'casino2k.png',
      amount: 2000
    },
    {
      imgName: 'casino5.png',
      amount: 5
    },
    {
      imgName: 'casino5k.png',
      amount: 5000
    },
    {
      imgName: 'casino10.png',
      amount: 10
    },
    {
      imgName: 'casino10k.png',
      amount: 10000
    },
    {
      imgName: 'casino20k.png',
      amount: 20000
    },
    {
      imgName: 'casino50k.png',
      amount: 50000
    }
  ];

  constructor(private alertController: AlertController, private toastController: ToastController) {}

  ngOnInit(): void {
    // Reset game
    this.resetGame();
  }

  @Input()
  set userBalance(balance: number) {
    if (balance) {
      this._userBalance = balance;
    }
  }

  get userBalance() {
    return this._userBalance;
  }

  @Input()
  set selectOption(selectOption: any) {
    if (selectOption) {
      this._selectOption = selectOption;
    }
  }

  get selectOption() {
    return this._selectOption;
  }

  /**
   * Observable to be subscribed to when a component has an option selected
   * @type {EventEmitter}
   */
  @Output() onOptionSelected: EventEmitter<any> = new EventEmitter();

  /**
   * Observable to be subscribed to when a component has total changed
   * @type {EventEmitter}
   */
  @Output() onTotalChanged: EventEmitter<any> = new EventEmitter();

  /**
   * Observable to be subscribed to when a component has changed
   * @type {EventEmitter}
   */
  @Output() onBetInfoChanged: EventEmitter<any> = new EventEmitter();

  /**
   * Insert "number" items to array numbers
   * @param number
   */
  initNumbersArray(number: number): any {
    let numbers = [];
    for (let i = 0; i < number; i++) {
      numbers.push({
        value: i + 1,
        betCoins: []
      });
    }

    return numbers;
  }

  /**
   * Add one bet coin to betCoins array with default value
   * @param option
   */
  addDefaultBetCoin(option: any) {
    if (option && option.betCoins) {
      option.betCoins.push({
        name: 'Coin zero',
        imgName: 'casino_transparent.png',
        amount: this._DEFAULT_BET_COIN_AMOUNT
      });
    }
  }


  /**
   * Reset all bet coins of input array
   * @param options
   */
  resetBetCoins(options = []) {
    if (options) {
      options.forEach(option => {
        if (option.betCoins) {
          option.betCoins.splice(0);
        }
      });
    }
  }

  /**
   * Reset all status to the beginning of the game
   */
  resetGame() {
    // TODO: Each child need to implement this function to reset game status
  }

  /**
   * Bet selected option(s)
   * @param bets
   */
  betOption(bets) {
    if (bets && bets.betCoins && bets.code) {
      this.addDefaultBetCoin(bets);
      this.currentBets = [bets.code];

      this.onOptionSelected.emit();
      LotteryPage.clickPlay();
    }
  }

  /**
   * Remove the last item from betting history
   */
  popBackBetHistory() {
    let poppedHistory = this.getElementBetHistory(this.currentBets);
    this.cancelCurrentBets();
    // remove data each back button again
    this.betInfo = this.setBetInfo();
    // emit data to lottery parent
    this.onBetInfoChanged.emit(this.betInfo);

    if (poppedHistory) {
      this.removeBets(poppedHistory.bets);

      // Toast a message to user
      AppDialog.toast({
        toastCtrl: this.toastController,
        message: `撤销成功: ${poppedHistory.bets.length * poppedHistory.amount}元`
      });

      // Refresh total
      let total = this.calculateTotal();
      this.onTotalChanged.emit(total);
    }
  }
  /**
   * get pop element from betHistory
   */
  getElementBetHistory(item: any) {
    for (let data of this.betHistory) {
      if (data.bets[0] == item) {
        let index = this.betHistory.indexOf(data);
        this.betHistory.splice(index, 1);
        return data;
      }
    }
    return this.betHistory.pop();
  }

  /**
   * Remove all items from betting history
   */
  clearBetHistory() {
    this.betHistory = [];
    // set betInfo is null
    this.betInfo = [];
    this.resetGame();
  }

  /**
   * Remove all items from current bets
   */
  clearCurrentBets() {
    if (this.currentBets.length > 0) {
      this.currentBets = [];
    }
  }

  /**
   * Get current bets
   * @returns {Array}
   */
  getCurrentBets(): any {
    return this.currentBets;
  }

  /**
   * Remove the last item out of current bets
   */
  popBackCurrentBets() {
    if (this.currentBets.length > 0) {
      this.currentBets.pop();
    }
  }

  /**
   * Set current bets
   * @param bets
   */
  setCurrentBets(bets = []) {
    if (bets) {
      this.currentBets = [...bets];
    }
  }

  /**
   * Cancel the current bets
   */
  cancelCurrentBets() {
    this.removeBets(this.currentBets);
    this.popBackCurrentBets();
  }

  /**
   * Remove a specific bets
   * @param bets
   */
  removeBets(bets) {
    // Empty method
    // TODO: Each derived class need to implement its self
  }

  /**
   * Get an option by its code
   * @param optionCode
   */
  getOptionByCode(optionCode): any {
    // Empty method
    // TODO: Each derived class need to implement its self
  }

  /**
   * Set selected coin to selected bet option
   * @param selectedCoin
   */
  setSelectedCoinForCurrentBets(selectedCoin) {
    this.currentBets.forEach(betOptionCode => {
      // Get selected bet option
      let option = this.getOptionByCode(betOptionCode);

      // Set coin to bet option
      if (option) {
        option.betCoins.pop(); // Remove temp transparent coin
        option.betCoins.push(selectedCoin);
      }
    });
  }

  /**
   * Check if current bets contains an option with total amount exceed maximum limit
   * @returns {boolean}
   */
  isCurrentBetsExceedLimit(selectedCoin): boolean {
    return this.currentBets.some(optionCode => {
      return this.calculateTotalByOptionCode(optionCode) + selectedCoin.amount > this.maxAmountPerOption;
    });
  }

  /**
   * Calculate total amount of a specific option code
   * @param code
   * @returns {number}
   */
  calculateTotalByOptionCode(code): number {
    let total = 0;

    this.betHistory.forEach(history => {
      if (history.bets.indexOf(code) >= 0) {
        total += history.amount;
      }
    });

    return total;
  }

  /**
   * Calculate the total amount for the current bet
   * @param selectedCoin
   */
  calculateCurrentBetTotal(selectedCoin) {
    let isCancelledCurrentBet = false;
    let alertMessage = '';

    // Calculate betTotal for current selected options
    let currentBetTotal = this.currentBets.length * selectedCoin.amount;
    let total = this.calculateTotal();

    // Check if user has enough money
    if (this.userBalance < total + currentBetTotal) {
      isCancelledCurrentBet = true;
      alertMessage = '你的余额不足';

    } else if (this.isCurrentBetsExceedLimit(selectedCoin)) {
      isCancelledCurrentBet = true;
      alertMessage = `金额超限，该玩法最多下注: ${ new Intl.NumberFormat('en-US').format(this.maxAmountPerOption) }元`;

    } else if (total + currentBetTotal > this.maxAmountPerBet) {
      // Check if exceed max amount per bet or not
      isCancelledCurrentBet = true;
      alertMessage = `金额超限，该玩法最多下注:<p>${ new Intl.NumberFormat('en-US').format(this.maxAmountPerBet) }元</p>`;
    }

    // Display alert message
    if (alertMessage !== '') {
      AppDialog.alert({
        alertCtrl: this.alertController,
        message: alertMessage
      });
    }

    if (isCancelledCurrentBet) {
      this.cancelCurrentBets();
    } else {
      this.setSelectedCoinForCurrentBets(selectedCoin);

      // Add bet history
      this.betHistory.push({
        bets: this.currentBets,
        amount: selectedCoin.amount,
      });
      // add betInfo each time addition number
      this.betInfo = this.setBetInfo();
      this.onBetInfoChanged.emit(this.betInfo);

      // Clear current bets
      this.clearCurrentBets();

      // Re-calculate betting history
      this.onTotalChanged.emit(total + currentBetTotal);
    }
  }
  /**
   * Add bet to betInfo
   * - "betdata[code][]":amount#number
   * - "betdata[YMZT][]"
   * - "betdata[TMX]"
   * - "betdata[TMD]"
   * - "betdata[TMDAN]"
   * - "betdata[TMS]"
   * - "betdata[WSD]"
   * - "betdata[WSX]"
   * - "betdata[WSDAN]"
   * - "betdata[WSS]"
   * - "betdata[SB_H]"
   * - "betdata[SB_L]"
   * - "betdata[SB_LV]"
   * - "betdata[SX_H]"
   * - "betdata[SX_J]"
   * - "betdata[SX_G]"
   * - "betdata[SX_Z]"
   * - "betdata[SX_S]"
   * - "betdata[SX_N]"
   * - "betdata[SX_HU]"
   * - "betdata[SX_T]"
   * - "betdata[SX_L]"
   * - "betdata[SX_SHE]"
   * - "betdata[hezhi_12]"
   * - "betdata[SX_MA]"
   * - "betdata[SX_Y]"
   * - "betdata[TMWS_0]"
   * - "betdata[TMWS_2]"
   * - "betdata[TMWS_3]"
   * - "betdata[TMWS_4]"
   * - "betdata[TMWS_5]"
   * - "betdata[TMWS_6]"
   * - "betdata[TMWS_7]"
   * - "betdata[TMWS_8]"
   * - "betdata[TMWS_9]"
   * - "betdata[TMWS_1]"
   * - "betdata[ZYMD]"
   * - "betdata[ZYMX]"
   * - "betdata[ZYMDAN]"
   * - "betdata[ZYMS]"
   * - "betdata[YMBDW][]"
   */
  setBetInfo() {
    return this.removeDuplicate([...this.betHistory]);
  }

  /**
   * Remove duplicate element from array
   */
  removeDuplicate(data: any) {
    let i = 0;
    while (i < data.length - 1) {
      let j = i + 1;
      while (j < data.length) {
        if(data[i].bets[0] == data[j].bets[0]) {
          // add amount to duplicate element
          data[i] = {
            amount: data[i].amount + data[j].amount,
            bets: [...data[i].bets]
          };
          // delete duplicate data
          data.splice(j, 1);
        } else {
          j++;
        }
      }
      i++;
    }
    return data;
  }
  /**
   * Calculate total based on betting history
   * @param selectedCoinAmount
   */
  calculateTotal(): number {
    let total: number = 0;

    // Loop through bet history and sum up total
    this.betHistory.forEach(history => {
      let currentTotal: number = history.bets.length * history.amount;
      total += currentTotal;
    });

    return total;
  }
}



// WEBPACK FOOTER //
// ./src/component/sixmark/sixMarkBase.ts